import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import "./GraphReport.css";
import { BASE_URL } from "./Config";
import { FiMenu } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { isSuperAdmin } from "../utils/auth";
import LoadingSpinner from "./LoadingSpinner";
import logoImage from "../resources/1000028180.jpeg";

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function GraphReport() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("admin_token");
      const response = await fetch(`${BASE_URL}/api/admin/analysis_data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch analysis data");
      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Prepare data for charts
  const sports = data.map((item) => item.sport);
  const avgScores = data.map((item) => item.avg_score);
  const numAthletes = data.map((item) => item.num_athletes);

  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuBtnStyle = {
    background: "none",
    border: "none",
    textAlign: "left",
    padding: "12px 20px",
    fontSize: "1rem",
    cursor: "pointer",
    width: "100%",
    transition: "background 0.18s",
    borderBottom: "1px solid #f1f1f1",
    color: "gray",
  };
  function logout() {
    navigate("/logout");
  }

  return (
    <>
      <div
        className="org-header"
        style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000 }}
      >
        <div className="header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div className="header-logo-container">
                                  <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo">Power Mind Metrics</h1>
          </div>
          <nav className="header-nav" style={{ marginLeft: 'auto' }}>
            <button
              onClick={() => setMenuOpen((prev) => !prev)}
              className="menu-button"
              aria-label="Open menu"
            >
              <FiMenu size={24} />
            </button>
          </nav>
        </div>
        {menuOpen && (
          <div className="menu-dropdown">
            {isSuperAdmin() ? (
              <>
                <button
                  style={menuBtnStyle}
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/AdminDashboard");
                  }}
                >
                  Admin Dashboard
                </button>
                <button
                  style={menuBtnStyle}
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/admin/sub-admins");
                  }}
                >
                  Manage Subadmin
                </button>
                <button
                  style={menuBtnStyle}
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/manage-users");
                  }}
                >
                  Manage Users
                </button>
                <button
                  style={menuBtnStyle}
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/organizations");
                  }}
                >
                  Manage Organization
                </button>
              </>
            ) : null}
            {!isSuperAdmin() && (
              <button style={menuBtnStyle} onClick={() => { setMenuOpen(false); navigate('/admin/sub-admins'); }}>Subadmin Dashboard</button>
            )}
            <button
              style={menuBtnStyle}
              onClick={() => {
                setMenuOpen(false);
                navigate("/graph-report");
              }}
            >
              Graph Report
            </button>

            <button
              style={menuBtnStyle}
              onClick={() => {
                setMenuOpen(false);
                logout();
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
      <div style={{ marginTop: "164px" }}></div>
      {/* graph */}
      <div className="graph-report-container">
        {/* Header with menu */}

        {/* <div style={{marginTop: '184px'}}></div> */}
        <h2 className="graph-report-title">Graph Report</h2>
        {loading && <div className="graph-loading"><LoadingSpinner /></div>}
        {error && <div className="graph-error">{error}</div>}
        {!loading && !error && (
          <>
            <div className="graph-section">
              <h3>Average Scores by Sport</h3>
              <Bar
                data={{
                  labels: sports,
                  datasets: [
                    {
                      label: "Average Score",
                      data: avgScores,
                      backgroundColor: "#0ea5e9",
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { display: false },
                    title: {
                      display: true,
                      text: "Average Score by Sport",
                    },
                  },
                  scales: {
                    x: {
                      // ticks: { maxRotation: 45, minRotation: 45 },
                    },
                  },
                  height: 500,
                  // width: 400,
                }}
              />
            </div>
            <div className="graph-section">
              <h3>Number of Athletes by Sport</h3>
              <Bar
                data={{
                  labels: sports,
                  datasets: [
                    {
                      label: "Number of Athletes",
                      data: numAthletes,
                      backgroundColor: "#38d39f",
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { display: false },
                    title: {
                      display: true,
                      text: "Athletes per Sport",
                    },
                  },
                  scales: {
                    x: {
                      // ticks: { maxRotation: 45, minRotation: 45 },
                    },
                  },
                  height: 500,
                }}
              />
            </div>
          </>
        )}
      </div>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </>
  );
}
